<script setup>
import OpportunityTable from '@frontJs/components/tables/projectManagement/apikom/OpportunityTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { h } from 'vue';

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>Opportunités - Apikom - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle> Gestion de projet - Apikom - Opportunités </PageTitle>

    <TabLayout
        :tabs="{
            eCommerce: {
                title: 'E-commerce',
                content: h(OpportunityTable, {
                    type: 'e-commerce',
                }),
            },
            showcase: {
                title: 'Showcase',
                content: h(OpportunityTable, {
                    type: 'showcase',
                }),
            },
        }"
    />
</template>
